import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, LOCATION, DOMAIN } from '../../utils/Constants';
import DocumentMeta from 'react-document-meta';
import HandleData from '../../utils/HandleData';

class SiteMap extends Component {
  categories = HandleData.sortData(CATEGORIES, 'name');
  render(){
    const meta = {
      title: `― Find businesses, services and events on ${LOCATION}, Essex, UK, search our business directory ―`,
      description: `Business directory for ${LOCATION}, Essex, UK. Find local businesses, services and events.`,
      canonical: `http://www.${DOMAIN}/sitemap`,
      meta: {
        keywords: `businesses, services, events, in ${LOCATION}, Essex, United Kingdom, business listings, business directory, businesses`
      }
      
    };
    return(
      <div className="row">
        <div className="large-12 columns">
          <DocumentMeta {...meta} />
          <ul className="sitemap">
            <li><Link to="/">{LOCATION} Online Home</Link></li>
            <li><Link to="/getfound">Get Found in {LOCATION}</Link></li>
            { this.categories.map((cat, idx) => (
              <li key={idx}>
                <Link 
                  onClick={this.handleMobileClick} 
                  to={`/businesses/${cat.dir}`}>
                    {cat.name} in {LOCATION}
                </Link>
              </li>
              ))
              }
          </ul>
        </div>
      </div>
     
    );
  }
}
export default SiteMap;


// WEBPACK FOOTER //
// ./src/components/pages/SiteMap.js